import { createTitleMutationObserver as realCreateTitleMutationObserver } from '@get-bridge/title-mutation-observer'

// This is a wrapper strictly to help sinon mock this.
export function createTitleMutationObserver(...args) {
  return realCreateTitleMutationObserver(...args)
}
